import { useState } from "react";
import { connect } from "react-redux";
import { useAuth } from "../auth/auth";
import Loader from "../components/Dialogs/Loader";
import DropzoneNetexFile from "../components/ImportNetexFile/DropzoneNetexFile";
import StopPlacesMap from "../components/Map/StopPlacesMap";

function ImportNetexFile(props) {
  const [isLoading, setIsLoading] = useState(false);
  const auth = useAuth();
  console.log("auth from useAuth:", auth);

  return (
    <div>
      {isLoading && <Loader />}
      <DropzoneNetexFile auth={auth} setIsLoading={setIsLoading} />
      <StopPlacesMap />
    </div>
  );
}

export default connect()(ImportNetexFile);
